import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultoria',
  templateUrl: './consultoria.component.html',
  styleUrls: ['./consultoria.component.css']
})
export class ConsultoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
